<template>
  <el-card shadow="never" header="业务员业绩详情">
    <div>
      <el-select
        v-model="selectedUsers"
        multiple
        clearable
        style="width: 100%"
        filterable
        default-first-option
        placeholder="请选择业务员"
      >
        <el-option
          v-for="item in details"
          :key="item.user_id"
          :label="item.screen_name"
          :value="item.user_id"
        />
      </el-select>
    </div>
    <br>
    <el-table :data="tableData" border stripe>
      <el-table-column prop="screen_name" label="业务员" min-width="100"></el-table-column>
      <el-table-column prop="sales_amount" label="开单金额" sortable min-width="200" v-if="performanceGoalTargets.includes('sales_target')">
        <template #default="{ row }">
          <div class="data-row">开单：<span class="text-primary">{{ row.sales_amount | toLocaleString }}</span></div>
          <div class="data-row">目标：{{ row.sales_target | toLocaleString }}</div>
          <div class="data-row">排名：{{ row.rank_by_sales_amount }}</div>
          <div class="progress-wrapper">
            <el-progress
              :percentage="calcProgressPercent(row.sales_amount, row.sales_target)"
              :color="progressColor"
              :show-text="false"
              :stroke-width="10"
            />
            <span class="percent-text">完成率：{{ calcFinishPercent(row.sales_amount, row.sales_target) }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { localeString } from '@/components/locale-string';
import Utils from '@/components/utils.vue';

@Component({
  filters: {
    toLocaleString(value) {
      return localeString({ value, showUnit: false }) || '-';
    }
  }
})
export default class Details extends Mixins(Vue, Utils) {
  @Prop({ type: Array, required: true }) details;

  selectedUsers = [];

  progressColor = '#1121BF' // 品牌色 rgb(17,31,191)

  calcFinishPercent(finishAmount, finishTarget) {
    return finishTarget ? (
      finishAmount ? `${((finishAmount / finishTarget) * 100).toFixed(2)}%` : '0%'
    ) : '-';
  }

  calcProgressPercent(amount, target) {
    if (!target || !amount) return 0;
    const percent = (amount / target) * 100;
    return Math.min(percent, 100);
  }

  get detailsDataNumberValue() {
    return this.details.map(item => {
      return {
        ...item,
        finish_amount: Number(item.finish_amount),
        finish_target: Number(item.finish_target),
        sales_amount: Number(item.sales_amount),
        sales_target: Number(item.sales_target),
        rank_by_finish_amount: Number(item.rank_by_finish_amount),
        rank_by_sales_amount: Number(item.rank_by_sales_amount),
        pending_finish_amount: Number(item.pending_finish_amount),
      }
    })
  }

  get tableData() {
    if (this.selectedUsers.length === 0) {
      return this.detailsDataNumberValue;
    }
    return this.detailsDataNumberValue.filter(item => this.selectedUsers.includes(item.user_id));
  }
}
</script>

<style lang="scss" scoped>
.progress-wrapper {
  display: flex;
  align-items: center;
  margin-top: 5px;

  .el-progress {
    flex: 1;
    margin-right: 8px;
  }

  .percent-text {
    min-width: 80px;
  }
}

.text-primary {
  font-weight: 500;
}
</style>
